import * as React from 'react';
import { Redirect } from 'react-router';

/**
 * Default Administration home page.
 */
export const AdministrationHome = () => {
    return (
        <>
            <Redirect to="/administration/subscriptions" />
        </>
        );
};